import { motion } from "framer-motion";

// Kinetic masked line-by-line reveal. Pass an array of lines.
export const MaskedHeading = ({
  lines = [],
  className = "",
  as: Tag = "h1",
  delay = 0,
}) => {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden"
          style={{ paddingBottom: "0.08em" }}
        >
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              delay: delay + i * 0.12,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
